/* istanbul ignore file */
import React from 'react';
import BreadcrumbItem from './BreadcrumbItem';
import type { EntityBreadcrumbItemProps } from '../BreadcrumbsTypes';

const UpdateBreadcrumbItem = ({ entity = '', ...props }: Partial<EntityBreadcrumbItemProps>) => {
  return <BreadcrumbItem {...props}>{`Edit ${entity}`}</BreadcrumbItem>;
};

export default UpdateBreadcrumbItem;
